import { createContext, useEffect, useReducer, useCallback, useMemo, useState } from 'react';
// utils
import useAPI from './useApi';
import axios from 'axios';
import localStorageAvailable from './localStorageAvailable';

import { isValidToken, setSession } from './utils';
import { BASE_URL } from '../config-global';

const initialState = {
  isAuthenticated: false,
  user: null,
};



// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------


export function AuthProvider({ children }) {
  const [state, setState] = useState(initialState);

  const storageAvailable = localStorageAvailable();
  const client = useAPI();
  
  const initialize = useCallback(async () => {
    try {
      const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
      const refreshToken = storageAvailable ? localStorage.getItem('refreshToken') : '';
      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken, refreshToken);
        const response = await client.getCurrentUser();

        const user = response;
        setState({isAuthenticated: true, user: user})
      } else {
        setState(initialState)
      }
    } catch (error) {
      console.error(error);
    }
  }, [storageAvailable]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // LOGIN
  const login = useCallback(async (username, password) => {
    try{
      const response = await client.signIn(
        username,
        password,
      );
      const { access, refresh } = response;

      // Conturile cu 2FA primesc 202 fără token-uri; verificarea codului se face în pagina de login.
      if (!access || !refresh) {
        setState(initialState);
        return response;
      }

      setSession(access, refresh);
      const user = await client.getCurrentUser();
      setState({isAuthenticated: true, user: user})
    }catch(error){
      setState(initialState)
    }

  }, [client]);

  // REGISTER
  const register = useCallback(
    async (email, password, firstName, lastName) => {
      const response = await axios.post(`${BASE_URL}/api/token/`, {
        email,
        password,
        firstName,
        lastName,
      });
      const { accessToken, user } = response.data;

      localStorage.setItem('accessToken', accessToken);

    },
    []
  );


// LOGOUT
const logout = useCallback(async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  setSession(null, null);
  try {
    const response = await client.logout(refreshToken);
    
  } catch (error) {
    console.error("Logout error:", error);
  }
}, []);


  const memoizedValue = useMemo(
    () => ({
      isAuthenticated: state.isAuthenticated,
      user: state.user,
      method: 'jwt',
      login,
      loginWithGoogle: () => {},
      loginWithGithub: () => {},
      loginWithTwitter: () => {},
      register,
      logout,
    }),
    [state.isAuthenticated, state.user, login, logout, register]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}